var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.31 41.2",
    style: {
      enableBackground: "new 0 0 47.31 41.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69716",
    transform: "translate(5865.987 3336.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37282",
    d: "M-5841.99-3317.01h-10.95c-0.74,0-1.34,0.6-1.34,1.34s0.6,1.34,1.34,1.34h10.97 c0.74-0.01,1.34-0.61,1.33-1.36C-5840.64-3316.42-5841.25-3317.02-5841.99-3317.01L-5841.99-3317.01L-5841.99-3317.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37283",
    d: "M-5837.72-3324.71h-15.23c-0.74,0-1.34,0.6-1.34,1.34s0.6,1.34,1.34,1.34h15.25 c0.74-0.01,1.34-0.6,1.34-1.34C-5836.37-3324.11-5836.97-3324.71-5837.72-3324.71L-5837.72-3324.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37284",
    d: "M-5837.72-3309.34h-15.23c-0.74,0-1.35,0.6-1.35,1.34s0.6,1.35,1.34,1.35h0.01h15.25 c0.74-0.01,1.34-0.6,1.34-1.34C-5836.37-3308.74-5836.97-3309.34-5837.72-3309.34L-5837.72-3309.34z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.8c14af13e934aa90e31bc80b322502bb.svg";
export { ForwardRef as ReactComponent };